<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdimensions.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input name="label" class="ir-form-set" type="text" formControlName="label" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdimensions.length' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input
                name="length"
                (input)="maxLengthCheck(editForm.controls.length, $event)"
                formControlName="length"
                class="ir-form-set"
                type="number"
                step="0.01"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdimensions.width' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input
                name="width"
                type="number"
                class="ir-form-set"
                (input)="maxLengthCheck(editForm.controls.width, $event)"
                min="0"
                step="0.01"
                formControlName="width"
              />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdimensions.height' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input
                name="height"
                class="ir-form-set"
                type="number"
                (input)="maxLengthCheck(editForm.controls.height, $event)"
                min="0"
                step="0.01"
                formControlName="height"
              />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdimensions.units' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="units" />
                <div class="ir-line ir-select th-select" (click)="openUnitsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.units.value && editForm.controls.units.value >= 0
                        ? (editForm.controls.units.value | measuringunits)
                        : ('plugins.installationdimensions.select-units' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectDimensionsMenu($event)" (modalClosed)="onClose($event)" #measuringUnitsModal></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
